import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  selectedFunnelId: null,
  templates: [],
  stageState: {},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
